import React, { useEffect } from 'react';
import Layout from '../components/Layout';
import { Card, CardContent } from "../components/ui/card";

const AboutJP = () => {
  useEffect(() => {
    document.title = 'Internjin | 会社概要';
  }, []);

  return (
    <Layout>
      <section className="py-20 bg-slate-50">
        <div className="container mx-auto px-4 md:px-6 max-w-4xl">
          <div className="text-center mb-16">
            <h1 className="text-4xl font-bold text-slate-900 mb-6">Internjinについて</h1>
            <p className="text-xl text-slate-600 max-w-2xl mx-auto">
              欧州の才能と日本のイノベーションをつなぐ究極の架け橋を築いています。
            </p>
          </div>

          <div className="prose prose-slate max-w-none mb-20">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">ミッション</h2>
            <p className="text-slate-600 mb-8">
              Internjinはシンプルな気付きから生まれました。日本は深刻な人材不足に直面している一方、フランスの学生は国際経験を熱望していますが、日本市場へのアクセスを持っていません。私たちは、エリートインターンシップのための合理的でサポートされた道を作り出すことで、両方の問題を同時に解決するために存在します。
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <Card className="border-none shadow-lg bg-white">
              <CardContent className="p-8 flex flex-col items-center text-center">
                <div className="h-24 w-24 bg-slate-200 rounded-full flex items-center justify-center mb-6 text-2xl font-bold text-slate-600">
                  PT
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-1">P. Theotime</h3>
                <p className="text-red-600 font-medium mb-6">共同創業者</p>
                <div className="text-slate-600 text-sm space-y-2">
                  <p>ロボット工学修士 (CPEリヨン)</p>
                  <p>元BMWジャパン インターン (東京)</p>
                </div>
              </CardContent>
            </Card>

            <Card className="border-none shadow-lg bg-white">
              <CardContent className="p-8 flex flex-col items-center text-center">
                <div className="h-24 w-24 bg-slate-200 rounded-full flex items-center justify-center mb-6 text-2xl font-bold text-slate-600">
                  DC
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-1">D. Chahan</h3>
                <p className="text-red-600 font-medium mb-6">共同創業者</p>
                <div className="text-slate-600 text-sm space-y-2">
                  <p>ロボット工学修士 (CPEリヨン)</p>
                  <p>元Sound & Vision インターン (大阪)</p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default AboutJP;
